module.exports = __webpack_public_path__ + "img/rsz_2africaunion.2fe07a79.png";